const eventMapping = {
  facebook: {
    click_register: null,
    click_otp_verify: null,
    click_binding_bank: null,
    click_free_credit: null,
    click_promo_code: null,
    // 內部 funnel 訊號，無 FB 對應；註：mapping = null 在 dispatcher 不會真正 block
    // FB（只 Umami branch 檢查 isEventBlocked），會以原 event name 經 trackCustom 送出。
    // 詳見 spec §4.1 footnote。BI 在 FB Pixel dashboard 應忽略這兩個自訂事件。
    claim_reward: null,
    claim_free_game: null,
    sign_up_success: 'CompleteRegistration',
    otp_verification_success: null,
    bank_verification_success: 'AddPaymentInfo',
    login_success: null,
    click_deposit: null,
    submit_deposit: 'InitiateCheckout',
    purchase: 'Purchase',
    activity_click: 'ViewContent',
    activity_detail: 'ViewContent',
    game_click: null,
    lobby_click: null,
    open_page: 'ViewContent',
    close_page: null,
    page_view: 'ViewContent',
    search: 'SEARCH',
  },
  kwai: {
    click_register: 'buttonClick',
    click_otp_verify: 'buttonClick',
    click_binding_bank: 'buttonClick',
    click_free_credit: 'buttonClick',
    click_promo_code: 'buttonClick',
    // 內部 funnel 訊號，無 Kwai 對應；註：mapping = null 在 dispatcher 不會真正 block
    // Kwai（只 Umami branch 檢查 isEventBlocked），會以原 event name 經 track() 送出。
    claim_reward: null,
    claim_free_game: null,
    sign_up_success: 'completeRegistration',
    otp_verification_success: null,
    bank_verification_success: 'addPaymentInfo',
    login_success: null,
    click_deposit: 'buttonClick',
    submit_deposit: 'initiateCheckout',
    purchase: 'purchase',
    activity_click: 'contentView',
    activity_detail: 'contentView',
    game_click: 'buttonClick',
    lobby_click: 'buttonClick',
    open_page: 'contentView',
    close_page: null,
    page_view: 'contentView',
    search: 'search',
  },
  umami: {
    // page lifecycle events（open_page / page_view / close_page）不再 block：dispatcher 統一派發
    // 與其他 tracker 對齊。Umami 的 Pageview metric 由 plugins/umami.client.js 的 router hook 透過
    // callback form 獨立 fire，不會被 component callsite 污染（pageview 與 custom event 是 Umami 兩種
    // 不同的紀錄類型；component 的 open_page 只進 Events tab，不影響 Pageview metric）。
  },
  tiktok: {
    click_register: 'ClickButton',
    click_otp_verify: 'ClickButton',
    click_binding_bank: 'ClickButton',
    click_free_credit: 'ClickButton',
    click_promo_code: 'ClickButton',
    // 內部 funnel 訊號，無 TikTok 對應；註：mapping = null 在 dispatcher 不會真正 block
    // TikTok（只 Umami branch 檢查 isEventBlocked），會以原 event name 經 track() 送出。
    claim_reward: null,
    claim_free_game: null,
    sign_up_success: 'CompleteRegistration',
    otp_verification_success: null,
    bank_verification_success: 'AddPaymentInfo',
    login_success: 'Login',
    click_deposit: 'ClickButton',
    submit_deposit: 'InitiateCheckout',
    purchase: 'PlaceAnOrder',
    activity_click: 'ViewContent',
    activity_detail: 'ViewContent',
    game_click: 'ClickButton',
    lobby_click: 'ClickButton',
    open_page: 'ViewContent',
    close_page: null,
    page_view: 'ViewContent',
    search: 'Search',
    // 無 TikTok 標準對應 → null（不 block；dispatcher 以原始名 track 送出 custom event）
    pwa_open: null,
    pwa_first_open: null,
  },
}
export function convertEventName(event, tracker) {
  let eventName = eventMapping[tracker] ? (eventMapping[tracker][event] ? eventMapping[tracker][event] : event) : event
  return eventName
}

// 顯式封鎖檢查：僅當 tracker 的 mapping 明確設為 null 時回傳 true（不影響未定義 key 的 fallback 行為）
export function isEventBlocked(event, tracker) {
  const map = eventMapping[tracker]
  return !!map && Object.prototype.hasOwnProperty.call(map, event) && map[event] === null
}
